module.exports = "/_next/static/images/FeaturedInLogos-e557ec8a2e9b74818230461a96fab471.png";